import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'product-description',
  template: `<ng-content></ng-content>`,
})
export class ProductDescriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
